import type { RevenuePoint } from './types';

export type RevenueRecord = { date: string; value: number };

function round(value: number): number {
  return Math.round(value * 100) / 100;
}

function formatIsoDate(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Convert a list of milestone points to a sorted `RevenueRecord[]`. Points
 * landing on the same calendar day are summed; zero-amount entries are
 * dropped (they're not "no override" — empty array means that). Equivalent
 * to the demo's per-month bucket logic, but emits per-date records to match
 * the new atomic storage model.
 */
export function applyPointInTime(points: RevenuePoint[]): RevenueRecord[] {
  const byDate = new Map<string, number>();

  for (const point of points) {
    const key = formatIsoDate(point.date);
    byDate.set(key, (byDate.get(key) ?? 0) + point.amount);
  }

  return [...byDate.entries()]
    .map(([date, total]) => ({ date, value: round(total) }))
    .filter((record) => record.value !== 0)
    .sort((a, b) => a.date.localeCompare(b.date));
}
